module.exports = "/_next/static/images/logo-f28a86137170572bf5c9590bfdeffe36.png";